export const enum MediaTypeType {
    IMAGE = "image",
    DOCUMENT = "document",
    VIDEO = "video",
}
